import { render, staticRenderFns } from "./UserActivityLog.vue?vue&type=template&id=7cf32c62&"
import script from "./UserActivityLog.vue?vue&type=script&lang=js&"
export * from "./UserActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports